import { apiInterfaceForJson } from "../common/apiManager";

export const getFilterShortcuts = () => {
    return apiInterfaceForJson("/filterShortcut/v1/", "GET");
};

export const getFilterShortcutById = (id) => {
    return apiInterfaceForJson("/filterShortcut/v1/" + id, "GET");
};

export const createFilterShortcut = (shortcutData) => {
    return apiInterfaceForJson("/filterShortcut/v1/", "POST", shortcutData);
};

export const updateFilterShortcut = (id, shortcutData) => {
    return apiInterfaceForJson("/filterShortcut/v1/" + id, "PUT", shortcutData);
};

export const deleteFilterShortcut = (id) => {
    return apiInterfaceForJson("/filterShortcut/v1/" + id, "DELETE");
};

